import Box from '@mui/material/Box';

import useStyles from './styles';

interface Props {
  title: string;
  description?: string | React.ReactNode;
  px?: number;
}

function SettingsHeader({ title, description, px = 4 }: Props) {
  const classes = useStyles();

  return (
    <Box mb={5} px={px}>
      <Box className={classes.title}>{title}</Box>
      <Box className={classes.description}>{description}</Box>
    </Box>
  );
}

export default SettingsHeader;
